import { Clause, LegalPage } from "@/pages/legal/LegalShell";
import { FEE_SECTIONS, LEGAL_CONTACTS } from "@/lib/legal";

export default function Fees() {
  return (
    <LegalPage
      title="Fees & settlement"
      intro="What a session costs, what the practitioner takes home, and which charges belong to the banks rather than to CARENEST."
      testId="fees-page"
    >
      {FEE_SECTIONS.map((s) => (
        <Clause key={s.title} heading={s.title} paras={s.paras} testId={`fees-${s.title.split(" ")[0].toLowerCase()}`} />
      ))}

      <Clause
        heading="Dispute window"
        paras={[
          "Escrow settles at session arrival plus a 24-hour dispute expiry window. Disputes raised in that window are adjudicated by the CARENEST administration team, with the audit log as the primary evidence.",
          `Questions about a settlement or a payout: ${LEGAL_CONTACTS.legal}.`,
        ]}
        testId="fees-dispute"
      />
    </LegalPage>
  );
}
